// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupedMetricBars_grid__3FAZ- {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
}

.GroupedMetricBars_card__Rb5ZG {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px 8px;
  min-width: 0;
}

.GroupedMetricBars_title__2SazV {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}

.GroupedMetricBars_valueLabel__xw\\+aS {
  fill: #ffffff;
  font-size: 12px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/GroupedMetricBars/GroupedMetricBars.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AACF","sourcesContent":[".grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n.card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 12px 14px 8px;\n  min-width: 0;\n}\n\n.title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 8px;\n}\n\n.valueLabel {\n  fill: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `GroupedMetricBars_grid__3FAZ-`,
	"card": `GroupedMetricBars_card__Rb5ZG`,
	"title": `GroupedMetricBars_title__2SazV`,
	"valueLabel": `GroupedMetricBars_valueLabel__xw+aS`
};
export default ___CSS_LOADER_EXPORT___;
